// import { VIBRATE } from './events'
// import { playMusic, playSound, vibrate } from 'classes/sound'
// import logger, { TAG_NAMES } from 'utils/Logger'
// import { SoundMap } from 'NativeModules/Sounds'
import { MUSIC } from '../../classes/sound/constants'
import { SoundMap } from '../../utils/Sound'
import { playMusic, playSound, vibrate } from '../../classes/sound'
import { VIBRATE } from './events'
import { _castArray, _forEach, _has } from '../../utils/helpers/zupeeLodash'
// import { MUSIC } from 'classes/sound/constants'

export const sendSoundEvents = events =>
  _forEach(_castArray(events), event => {
    if (event?.name === VIBRATE) {
      vibrate()
    } else if (event?.name === MUSIC) {
      playMusic()
    } else if (_has(SoundMap, event?.name)) {
      try {
        playSound(event?.name)
      } catch (error) {
        // logger(TAG_NAMES.SOUND, 'sendSoundEvents', {
        //   isBreadcrumb: true,
        //   isLogToFile: false,
        //   error
        // })
      }
    }
  })
